module.exports = __webpack_public_path__ + "static/media/wm_cvm_logo_primary.bdf8c52d.png";